import dateFormat from 'dateformat';
import SaveConfiguration from '../core/saved_configuration/save-configuration';
import AnalyticsHelper from '../utils/analytics-helper';
import ChatBotServices from '../utils/chatbot-services';
import CurrencyFormatter from '../utils/currency-formatter-lib';
import Router from '../utils/router';
import Login from './login';
import SaveForLater from './save-for-later';
import './scss/save-for-later-no-config-state.scss';
import './scss/save-for-later.scss';

export default class SaveForLaterSPA {
    constructor(el) {
        this.el = el;
        this.saveCarConfText = 'save-for-later';
        this.myAccount = window.HONDA.MyAccount;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.currency = window.HONDA.currency;
        this.router = window.HONDA.Router;
        this.saveForLater = new SaveForLater(this);
        this.login = new Login(this);
        this.chatEl = el.querySelector('.live-chat-wrapper');
        this.liveChat = new ChatBotServices(this.chatEl);
        this.savedItems = el.querySelector('.saved-items');
        this.savedItemCountEle = document.querySelectorAll('.saved-item-count');
        this.utils = {
            formatPrice: new CurrencyFormatter().to,
            formatFinance: new CurrencyFormatter({
                roundToDecimalPlace: +this.currency.roundToDecimalPlaceFinance || 0,
            }).to,
            formatAPR: (apr) => (apr ?? 0).toFixed(+this.currency.roundToDecimalPlaceFinanceAPR),
            pipeToSpace: (str) => str.replaceAll('|', ' '),
            capitalize: (str) => str && str[0].toUpperCase() + str.slice(1),
            dateFormat,
        };
        this.noConfigScript = this.el?.querySelector('#no-config-state');
        this.noConfigTemplate = this.noConfigScript
            ? _.template(this.noConfigScript.innerHTML.replaceAll('\\', ''))
            : null;
        this.bind();
        this.routes();
        this.render();
        this.saveForLater.sync();
    }

    bind() {
        this.el.addEventListener('click', (e) => this.remove(e));
    }

    remove(e) {
        const el = e.target;
        const target = el.classList.contains('remove-item') ? el : el.closest('.remove-item');
        if (target) {
            const { id } = target.closest('.saved-item-container');
            const item = this.saveForLater.get(id);
            if (item) {
                this.saveForLater.remove(item);
                AnalyticsHelper.push(target);
                SaveConfiguration.updateSavedCountInNavigation();
            }
        }
    }

    routes() {
        this.router.add('saveConfiguredCar', () => this.save('HondaCarConfiguratorOffer', 'url')).match();
    }

    save(type, from) {
        const item = this.saveForLater.create(type, from);
        if (item) {
            this.saveForLater.save(item);
        }
    }

    update() {
        if (this.router.path === '#saveConfiguredCar') {
            this.router.clear();
        }
        this.render();
        window.HONDA?.MyAccount2?.onLogin();
    }

    render() {
        if (this.saveForLater.saved.length > 0) {
            const { utils } = this;
            this.savedItems.innerHTML = this.saveForLater.saved
                .sort((i1, i2) => new Date(i1.data.dateCreated) - new Date(i2.data.dateCreated))
                .reverse()
                .map((item) => item.render({ utils }))
                .join('');
            this.el.classList.remove('no-items');
        } else {
            this.el.classList.add('no-items');
            this.savedItems.innerHTML = this.noConfigTemplate?.();
        }

        SaveConfiguration.updateSavedCountInNavigation();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.save-for-later');
    if (el) {
        window.HONDA.Router = window.HONDA.Router || new Router();
        const spa = new SaveForLaterSPA(el);
        window.HONDA.SaveForLater = spa;
    }
});
